import SurveyApi from './SurveyApi';
export default SurveyApi;
